import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  PermissionTypes,
  getActiveTenant$,
  selectTenantApplications
} from '@arc/arc-shared-frontend';
import { Observable, map, shareReplay, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  applications: string[];
  canManageTenants: boolean;

  constructor(
    private store: Store<any>,
    private permissionDefinition: PermissionTypes
  ) {
    this.store
      .pipe(select(selectTenantApplications))
      .subscribe(applicationIds => (this.applications = applicationIds));

    this.getCanManageTenants().subscribe(res => (this.canManageTenants = res));
  }

  hasApplication = (applicationId: string): boolean =>
    this.applications?.some(application => application === applicationId);

  public resellerId$: Observable<string> = getActiveTenant$(this.store).pipe(
    map(activeTenant => activeTenant?.resellerId ?? 'BILLTRUST'),
    shareReplay(1)
  );

  public resellerName = (resellerId: string): string => {
    switch (resellerId.toUpperCase()) {
      case 'JPMORGAN':
        return 'J.P. Morgan';
      default:
        return 'billtrust';
    }
  }

  private getCanManageTenants = (): Observable<boolean> => {
    return getActiveTenant$(this.store).pipe(
      switchMap(activeTenant => {
        return this.permissionDefinition
          .isPermitted$(
            'arc-permission-section-tenant-management-applicationandfeaturemanagement:read'
          )
          .pipe(map(hasPermission => hasPermission && activeTenant.isPartner));
      })
    );
  };
}
